import { render, staticRenderFns } from "./productBuyModel.vue?vue&type=template&id=199f8f6c&scoped=true&lang=pug&"
import script from "./productBuyModel.vue?vue&type=script&lang=js&"
export * from "./productBuyModel.vue?vue&type=script&lang=js&"
import style0 from "./productBuyModel.vue?vue&type=style&index=0&id=199f8f6c&lang=scss&scoped=true&"
import style1 from "./productBuyModel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199f8f6c",
  null
  
)

export default component.exports